import { mapFieldsToMomentDate as mapper, momentParse } from 'react-lib/dist/dates-es';
import { getObjPropRecursively } from './utils';
import moment from 'moment';

export const mapFieldsToMomentDate = (a, b) => mapper(a, b, momentParse);

export const defaultDateFormat = 'DD-MMM-YYYY HH:mm:ss';
export const defaultDateFormatJustDate = 'DD-MMM-YYYY';
export const defaultDateFormatJustTime = 'HH:mm:ss';
export const backendDateFormat = 'YYYY-MM-DD'

const getArrayDateFields = (data, arrayName, propName, prefix = '') => {
  let arrayDateFields = [];
  let arrayValue = getObjPropRecursively(data, arrayName);
  if (arrayValue)
    for (let i = 0; i < arrayValue.length; i++)
      arrayDateFields.push(`${prefix}${arrayName}[${i}].${propName}`);
  return arrayDateFields;
};

export const transformChemicalProductDatesToMoment = data => {
  return mapFieldsToMomentDate(data, [
    'createDte',
    'updateDte',
    'delDte',
    'histCreateDte',
    'validateDte',
    ...getArrayDateFields(data, 'sdsFiles', 'revisionDte')
  ]);
};

export const transformChemicalProductSdsFilesDatesToMoment = data => {
  return mapFieldsToMomentDate(data, [...getArrayDateFields(data, 'sdsFiles', 'revisionDte')]);
};

const getInventoryDatesToTransform = (data, prefix = '') => {
  return [
    prefix + 'checkDte',
    prefix + 'checkCseDte',
    prefix + 'createDte',
    prefix + 'updateDte',
    prefix + 'histCreateDte',
    prefix + 'delDte',
    prefix + 'chemicalProduct.validateDte',
    prefix + 'chemicalRiskAttributes.checkCseDte',
    ...getArrayDateFields(data, 'chemicalProduct.sdsFiles', 'revisionDte', prefix)
  ];
};

export const transformInventoryDatesToMoment = data =>
  mapFieldsToMomentDate(data, getInventoryDatesToTransform(data));

export const transformInventoryInitialDataDatesToMoment = data =>
  mapFieldsToMomentDate(data, getInventoryDatesToTransform(data, 'inventory.'));

export const isDateOlderThan1Year = date => {
  if (date) {
    const todayMinusOneYear = new moment().add(-1, 'years');
    const dateMoment = moment(date, defaultDateFormat);
    return dateMoment.isBefore(todayMinusOneYear);
  } else return false;
};
